import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { LocalStorageService } from '../../../../core/services/localStorage/local-storage.service';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { AuthStateService } from '../../../../core/services/auth-state/auth-state-service.service';
import { FormatNumberPipe, FormatNumberPipe2, FormatNumberPipe3 } from '../../../../core/pipe/custom-pipes';
import { BadgeVehiclePipe } from '../../../../core/pipe/badge-vehicle.pipe';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';

interface AccountData {
  reference: string;
  lastname: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}

@Component({
  selector: 'app-campaign-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    FormatNumberPipe,
    FormatNumberPipe2,
    FormatNumberPipe3,
    BadgeVehiclePipe,
    NgSelectModule,
    MatTooltipModule,
    CommonModule],
  templateUrl: './campaign-form.component.html',
  styleUrl: './campaign-form.component.css'
})
export class CampaignFormComponent {
  @Input() campaignData?: any;
  @Input() ladata: any = [];
  @Output() emitSubmit = new EventEmitter<string>();
  account_type = this.authStateService.getAccountType();
  @ViewChild('ivaCheckbox') ivaCheckbox!: ElementRef;
  generalForm: FormGroup = new FormGroup({});
  matrix_total: any = {};
  campaign_id: string = '';
  draft = false;
  order_reference: string = '';
  stage?: any;
  newStage: string = '';

  role: any;

  back = "";
  next_ok = "";
  next_ko = "";
  btn_fast_actions = false;
  agentData: AccountData[] = [];
  vendorData: AccountData[] = [];
  brokerData: AccountData[] = [];
  supplierData: AccountData[] = [];
  campaignsData: any[] = [];
  supplierTypeData: any[] = [{ name: 'Prescripción broker', key: 'referral_broker' }, { name: 'Prescripción devolución', key: 'referral_vendor' }];
  supplierSellerCodes: any[] = [];

  newCampaign: any = null;
  duration: string = '';
  monthly_fee_base: number = 0;
  yearly_kms: string = '';


  constructor(private fb: FormBuilder, private authStateService: AuthStateService, private modelService: ModelService, private alertService: AlertService, private localStorageService: LocalStorageService, private orderService: OrdersService) {
    this.generalForm = this.fb.group({
      broker_id: ['', Validators.required],
      broker_agent_id: ['', Validators.required],
      broker_reference: ['', Validators.required],
      duration: ['', Validators.required],
      yearly_kms: ['', Validators.required],
    });
  }

  columns: string[] = [];
  rows: string[] = [];

  ngOnInit(): void {
    this.check_selects_length();
  }

  selectedOpt: boolean = false;
  colKey: string = '';
  rowKey: string = '';

  handleClick(column: string, row: string) {
    this.selectedOpt = true;
    this.colKey = column;
    this.rowKey = row;
    const matrix = this.newCampaign?.matrix_base || {};
    const value = matrix[this.colKey]?.[this.rowKey] ?? null;
    this.duration = column;
    this.monthly_fee_base = value;
    this.yearly_kms = row;
  }


  ngAfterViewInit() {

  }

  isDisabled = false;

  toggleDisabled(): void {
    this.isDisabled = !this.isDisabled;
  }

  onCheckboxChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.matrix_total = this.newCampaign?.matrix_total;
      this.updateMatrixTotal();
    } else {
      this.matrix_total = this.newCampaign?.matrix_base;
      this.updateMatrixTotal();
    }
  }

  customConfig: boolean = false;
  onCheckboxChange2(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.customConfig = true;
    } else {
      this.customConfig = false;
    }
  }

  check_selects_length() {
    if (this.agentData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ broker_agent_id: this.agentData[0].reference });
      this.generalForm.patchValue({ supplier_agent_id: this.agentData[0].reference });
    }
    if (this.brokerData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ broker_id: this.brokerData[0].reference });
    }
    if (this.supplierData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ supplier_id: this.supplierData[0].reference });
    }
    if (this.vendorData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ vendor_id: this.vendorData[0].reference });
    }
  }

  checkUpdateForm(): boolean {
    if (this.generalForm.dirty) {
      return true;
    } else {
      return false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
        this.role = this.authStateService.getRole();
        this.agentData = this.ladata.agentData;
        this.vendorData = this.ladata.vendorData;
        this.brokerData = this.ladata.brokerData;
        this.supplierSellerCodes = this.ladata.supplierSellerCodes;
        this.supplierData = this.ladata.supplierData;
        this.campaignsData = this.ladata.campaignData;
        if (this.account_type == 'broker' && !this.draft) {
          this.generalForm.controls['broker_agent_id'].setValue(
            this.authStateService.getUserReference()
          );
        }
        if (this.campaignData) {
          this.refrescarFormulario();

        }
      }

      if (changes['campaignData']) {

        if (this.campaignData) {

          this.refrescarFormulario();
        }
      }
    }
  }
  campaign: any = null;


  updateMatrixTotal() {
    this.columns = Object.keys(this.matrix_total).sort((a, b) => +a - +b);
    // Extraer filas (kms)
    const kmSet = new Set<string>();
    Object.values(this.matrix_total).forEach(row => {
      Object.keys(row as object).forEach(km => kmSet.add(km));
    });

    this.rows = Array.from(kmSet).sort((a, b) => +a - +b);

    if (this.selectedOpt) {
      this.handleClick(this.colKey, this.rowKey);
    }
  }

  refrescarFormulario() {
    this.setVariables();
    setTimeout(() => {
      if (this.ivaCheckbox?.nativeElement) {
        this.ivaCheckbox.nativeElement.checked = true;
      }
    });
    
    this.updateFieldAccessibility();
    for (const key in this.campaignData) {
      const control = this.generalForm.controls[key];
      const value = this.campaignData[key];
      if (control) {
        control.setValue(value);
      }
      if (control) {
        switch (key) {
          case 'broker_agent_id':
            if (this.account_type === 'broker') {
              control.setValue(value);
            } else {
              const brokerAgentName = `${this.campaignData?.broker_agent?.name || ''} ${this.campaignData?.broker_agent?.lastname || ''}`.trim();
              this.generalForm.get('broker_agent')?.setValue(brokerAgentName);
              control.setValue(value);
            }
            break;
          case 'supplier_agent_id':
            if (this.account_type === 'supplier') {
              control.setValue(value);
            } else {
              const supplierAgentName = `${this.campaignData?.supplier_agent?.name || ''} ${this.campaignData?.supplier_agent?.lastname || ''}`.trim();
              this.generalForm.get('supplier_agent')?.setValue(supplierAgentName);
              control.setValue(value);
            }
            break;
          default:
            control.setValue(value);
            break;
        }
      }
    }
    this.btn_fast_actions = this.campaignData?.next_ok || this.campaignData?.next_ko ? true : false;
    this.alertService.close();
  }

  updateFieldAccessibility() {
    /*   // Deshabilitar todos los campos por defecto
      for (const field in this.generalForm.controls) {
        if (this.generalForm.controls.hasOwnProperty(field)) {
          this.generalForm.get(field)?.enable();
        }
      } */
  }

  onSubmitOrderFast(stage: string) {
    this.emitSubmit.emit(stage);
  }

  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  setVariables() {
    this.newCampaign = this.campaignData;
    this.campaign = this.campaignData;
    this.matrix_total = this.newCampaign?.matrix_total;
    this.campaign_id = this.campaignData?.reference || '';
    this.updateMatrixTotal();

  }

  getForm() {
    let formData;
    const values = this.generalForm.value;
    if (this.customConfig) {
      formData = {
        campaign_id: this.campaign_id,
        duration: values.duration,
        yearly_kms: values.yearly_kms,
        total_kms: (Number(values.yearly_kms) * (Number(values.duration) / 12)).toFixed(0),
      };
    } else {
      formData = {
        campaign_id: this.campaign_id,
        duration: this.duration,
        monthly_fee_base: parseFloat(this.monthly_fee_base.toFixed(2)),
        monthly_fee_tax: parseFloat((this.monthly_fee_base * 21 / 100).toFixed(2)),
        monthly_fee_total: parseFloat((this.monthly_fee_base + (this.monthly_fee_base * 21 / 100)).toFixed(2)),
        yearly_kms: this.yearly_kms,
        total_kms: (Number(this.yearly_kms) * (Number(this.duration) / 12)).toFixed(0)
      };
    }


    return {
      ...this.generalForm.value,
      ...formData,
    };
  }
}
